<template>
  <div class="itinerario-wrapper">
    <div class="rasgado rasgado-superior"></div>

    <section class="itinerario-section">
      <div class="timeline-container">
        <h2 class="timeline-title">
          Itinerary
          <span class="sub">
            We appreciate your punctuality. <br />
            We don’t want to start without you or let you miss any special moment! Please arrive on time to enjoy every unforgettable moment.
          </span>
        </h2>

        <div class="timeline">
          <div
            v-for="evento in eventos"
            :key="evento.nombre"
            :ref="el => eventoRefs.push(el)"
            class="timeline-item"
          >
            <div class="timeline-line" />

            <div class="timeline-icon-wrapper">
              <div class="timeline-star">★</div>
              <div class="timeline-icon-circle">
                <img :src="evento.icono" :alt="evento.nombre" class="timeline-icon" />
              </div>
            </div>

            <div class="timeline-content">
              <h3 class="timeline-name">{{ evento.nombre }}</h3>
              <div class="timeline-time">
                <p>{{ evento.hora }}</p>
                <p v-if="evento.nota" class="nota">{{ evento.nota }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="rasgado rasgado-inferior"></div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'ItinerarioComponent',
  setup() {
    const eventos = [
      {
        nombre: 'Reception',
        hora: '5:30 PM',
        icono: require('@/assets/recepcion_time.png'),
      },
      { 
        nombre: 'Dinner', 
        hora: '6:00 PM', 
        icono: require('@/assets/cena_time.png')
      },
      { 
        nombre: 'Presentation', 
        hora: '8:00 PM', 
        icono: require('@/assets/vals_time.png')
      },
      { 
        nombre: 'Dance', 
        hora: '10:00 PM – onward', 
        icono: require('@/assets/fiesta_time.png')
      }
    ]

    const eventoRefs = ref([])

    onMounted(() => {
      eventoRefs.value.forEach((el) => {
        if (!el) return
        const icon = el.querySelector('.timeline-icon')
        const star = el.querySelector('.timeline-star')
        const time = el.querySelector('.timeline-time')
        const name = el.querySelector('.timeline-name')

        gsap.set([icon, star, time, name], { opacity: 0, y: 50 })
        gsap.set(star, { scale: 0.6, rotate: -20 })

        const observer = new IntersectionObserver((entries, obs) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return

            gsap.to(name, { opacity: 1, y: 0, duration: 0.9, ease: 'power2.out' })
            gsap.to(icon, { opacity: 1, y: 0, delay: 0.1, duration: 0.9, ease: 'power2.out' })
            gsap.to(star, { opacity: 1, scale: 1, rotate: 0, delay: 0.25, duration: 0.9, ease: 'back.out(1.7)' })
            gsap.to(time, { opacity: 1, y: 0, delay: 0.35, duration: 0.9, ease: 'power2.out' })

            gsap.fromTo(name, { '--shift': '0%' }, { '--shift': '100%', duration: 1.2, ease: 'power2.out', delay: 0.15 })

            gsap.to(el.querySelector('.timeline-icon-circle'), {
              scale: 1.04,
              duration: 2.2,
              ease: 'sine.inOut',
              yoyo: true,
              repeat: -1
            })

            obs.unobserve(entry.target)
          })
        }, { threshold: 0.3 })

        observer.observe(el)
      })
    })

    return { eventos, eventoRefs }
  }
}
</script>

<style scoped>
.itinerario-wrapper { position: relative;  visibility: visible;
 }

.itinerario-section {
  padding: 40px 20px;
    visibility: visible;

  background-image:
    linear-gradient(to bottom, rgba(182, 216, 240, 0.527), rgba(255,255,255,0.68)),
    url('@/assets/brillos.avif');
  background-size: cover;
  background-position: center;
  margin-top: -20px;
  margin-bottom: -20px;
  color: #202020;
}

.timeline-container {
  max-width: 330px;
  margin: 20px auto 0;
  position: relative;
}

.timeline-title {
  text-align: center;
  font-family: "titulos", cursive;
  font-size: 66px;
  margin-bottom: 40px;
  color: #262525;
}

.timeline-title .sub {
  display: block;
  font-size: 20px;
  font-family: serif;
  margin-top: 8px;
  color: #434040;
}

/* ===== Timeline ===== */
.timeline {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 40px;
  border-left: 3px solid rgb(202, 202, 216);
}

.timeline-item {
  position: relative;
  padding-left: 30px;
  margin-bottom: 50px;
  display: flex;
  align-items: center;
}

.timeline-line {
  position: absolute;
  top: 0;
  left: -1.5px;
  width: 3px;
  height: 100%;
  background-color: rgb(30, 30, 31);
  z-index: -1;
}

.timeline-icon-wrapper { display: flex; align-items: center; }

.timeline-star {
  color: #0b0a0a;
  font-size: 22px;
  margin-right: 10px;
  transform-origin: center;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  min-height: 30px;
}

.timeline-icon-circle {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: rgb(80, 77, 77);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 18px rgba(0,0,0,0.18);
}

.timeline-icon { width: 40px; height: 40px; object-fit: contain; }

/* ===== Contenido (Nombre + Hora/Nota) ===== */
.timeline-content { margin-left: 15px; }

.timeline-name {
  font-family: 'Playfair Display', serif;
  font-weight: 600;
  font-size: 20px;
  color: #3a3838;
  line-height: 1.25;
  margin: 0 0 6px;

  /* alineado a la izquierda */
  text-align: left;
  display: block;
  width: 100%;

  /* subrayado decorativo con animación */
  position: relative;
  --shift: 0%;
  background:
    linear-gradient(90deg, rgba(0,0,0,0) var(--shift),
                    rgba(0,0,0,0.08) var(--shift),
                    rgba(0,0,0,0) calc(var(--shift) + 28%));
  background-repeat: no-repeat;
  background-size: 220% 2px;
  background-position: 0 100%;
  padding-bottom: 2px;
}


.timeline-time {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 16px;
  color: #0f0e0e;
  text-align: left;
}

.timeline-time .nota {
  font-size: 14px;
  color: #010000;
  margin-top: 4px;
  font-style: italic;
}

/* ===== Rasgados ===== */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background: #fff;
  z-index: 12;
  pointer-events: none;
}

.rasgado-superior {
  top: 0;
    background: #8fbbdf;

  clip-path: polygon(0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%, 100% 0%, 0% 0%);
}

.rasgado-inferior {
  bottom: 0;
  background: #8fbbdf;
  
  clip-path: polygon(0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%, 100% 100%, 0% 100%);
}

/* ===== Responsivo ===== */
@media (min-width: 420px) {
  .timeline-container { max-width: 480px; }
  .timeline-name { font-size: 22px; }
}
</style>
